module.exports = __webpack_public_path__ + "img/标语.eb0d960f.png";